export default "__VITE_ASSET__6HXxoKw___"